import { useState, useEffect } from 'react';
import { getRetellVoices } from '../../services/retellService';
import type { RetellVoice } from '../../services/retellService';

interface ViewVoiceModalProps {
  voiceId: string;
  onClose: () => void;
}

export function ViewVoiceModal({ voiceId, onClose }: ViewVoiceModalProps) {
  const [voice, setVoice] = useState<RetellVoice | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getRetellVoices().then((voices) => {
      setVoice(voices.find((v) => v.voice_id === voiceId) || null);
      setLoading(false);
    });
  }, [voiceId]);

  const labelClass = 'text-xs font-medium text-gray-500 uppercase tracking-wide';
  const valueClass = 'text-sm text-gray-900 mt-0.5';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-lg w-full max-w-sm mx-4">
        <div className="px-6 pt-6 pb-4">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Voice Details</h2>
          {loading ? (
            <p className="text-sm text-gray-400">Loading...</p>
          ) : !voice ? (
            <p className="text-sm text-gray-400">Voice not found</p>
          ) : (
            <div className="space-y-3">
              <div>
                <p className={labelClass}>Name</p>
                <p className={valueClass}>{voice.voice_name}</p>
              </div>
              <div>
                <p className={labelClass}>Id</p>
                <p className={valueClass}>{voice.voice_id}</p>
              </div>
              <div>
                <p className={labelClass}>Provider</p>
                <p className={valueClass}>{voice.provider || '—'}</p>
              </div>
              <div>
                <p className={labelClass}>Accent</p>
                <p className={valueClass}>{voice.accent || '—'}</p>
              </div>
              <div>
                <p className={labelClass}>Gender</p>
                <p className={valueClass}>{voice.gender || '—'}</p>
              </div>
            </div>
          )}
        </div>
        <div className="flex items-center justify-end px-6 py-4 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
